import { IsArray, IsOptional, IsString } from "class-validator";

export class TemplateImagesDto {
  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  tags?: string[];
}
